import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.css'
import './assets/css/iconfont.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
    next((resp) => {
        if (resp.data.code == -150 && location.hash.indexOf("home/login") == -1) {
        alert("用户登录失效，请重新登录")
        // 登录失效
        location.href = "/"
        }
    });
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
